import { call, delay, put, select } from "redux-saga/effects";
import LocalStorageLib from "@gcloud-npm/utils.secure.local-storage";
import { getAddress } from "@bitComponents/adabyron/addresses";
import { searchHorizontalAddresses } from "@bitComponents/adabyronLayer/horizontalAddress";
import { searchVerticalAddresses } from "@bitComponents/adabyronLayer/verticalAddress";
import { getAddressById as getAddressByIdPromise } from "@bitComponents/adabyronLayer/getAddressById";
import { WEB_SERVICES } from "./webServices";

const contextStore = (state) => state.context.data;

const ADDRESS_HANDLED_ERRORS = {
  ADDRESS_NOT_FOUND: "TCOL-PEDIDOS-014",
};

const normalizeSearchAddressFailResult = (rawData) => {
  let errorNormalized = null;
  const { response } = rawData;

  if (
    response &&
    response.status === "KO" &&
    response.error &&
    response.error.codigoErrorNegocio
  ) {
    switch (response.error.codigoErrorNegocio) {
      case ADDRESS_HANDLED_ERRORS.ADDRESS_NOT_FOUND:
        errorNormalized = ADDRESS_HANDLED_ERRORS.ADDRESS_NOT_FOUND;
        break;
      default:
        break;
    }
  }
  return errorNormalized;
};

export function* getAddresses(params) {
  const { normalizeHttpErrors, showError, address, vertical, reduxUpdate } =
    params;
  try {
    const { successUpdate } = reduxUpdate;
    const args = {
      horizontalAddress: address,
      verticalAddress: vertical,
    };
    const context = yield select(contextStore);

    const response = yield call(getAddress, args, context);
    yield put(successUpdate(response));
  } catch (error) {
    const data = normalizeSearchAddressFailResult(error);
    const { errorUpdate } = reduxUpdate;
    let errorNormalized = "";

    switch (data) {
      case ADDRESS_HANDLED_ERRORS.ADDRESS_NOT_FOUND:
        break;
      default:
        errorNormalized = normalizeHttpErrors(
          WEB_SERVICES.GET_HORIZONTAL_ADDRESS,
          error
        );
        if (showError) {
          yield put(showError(errorNormalized));
        }
        yield put(errorUpdate());
        break;
    }
  }
}

export const normalizeAddressResponse = (data) => {
  if(data && data.response && Array.isArray(data.response) && data.response.length > 0) {
    const newData = data.response
      .map((item) => {
        const { address, idGeographicSite, full } = item;
        return {
          address,
          label: address,
          value: idGeographicSite,
          id: idGeographicSite,
          full,
        };
      })
    return newData;
  }
  return null;
};

export function* getHorizontalAddresses(params) {
  const { address, normalizeHttpErrors, reduxUpdate } = params;
  try {
    const { successUpdate } = reduxUpdate;
    const context = yield select(contextStore);
    let orderPC='';
    const localStorageLib = new LocalStorageLib();
    const secure = localStorageLib.getItem("ts");
    if(secure && secure.geo){
      ({ cp: orderPC } = secure.geo);
    }
    const args = {
      params: { address, orderPC: orderPC || '28030' },
      context,
    };
    yield delay(300);
    if (address && address.length >= 3) {
      const response = yield call(searchHorizontalAddresses, args);
      const normalizedResponse = normalizeAddressResponse(response);
      yield put(successUpdate(normalizedResponse));
    } else {
      yield put(successUpdate(null));
    }
  } catch (error) {
    console.log(error);
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(
      normalizeHttpErrors,
      WEB_SERVICES.GET_HORIZONTAL_ADDRESS,
      error
    );
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}

export function* getVerticalAddresses(params) {
  const { address, id, normalizeHttpErrors, reduxUpdate } = params;
  try {
    const { successUpdate } = reduxUpdate;
    const context = yield select(contextStore);  
    const args = {
      params: { address, id },
      context,
    };
    yield delay(300);
    if (address === '' || (address && address.length >= 0)) {
      const response = yield call(searchVerticalAddresses, args);
      const normalizedResponse = normalizeAddressResponse(response);
      yield put(successUpdate(normalizedResponse));
    } else {
      yield put(successUpdate(null));
    }
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(
      normalizeHttpErrors,
      WEB_SERVICES.GET_VERTICAL_ADDRESS,
      error
    );
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}

export function* getAddressById(params) {
  const { id, normalizeHttpErrors, reduxUpdate } = params;
  try {
    const { successUpdate } = reduxUpdate;
    const context = yield select(contextStore);  
    const args = {
      params: { id },
      context,
    };
    const data = yield call(getAddressByIdPromise, args);
    yield put(successUpdate(data.response.address));
    
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(
      normalizeHttpErrors,
      WEB_SERVICES.GET_ADDRESS_BY_ID,
      error
    );
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
